const MEMBERSHIP_TIERS = [
  'Executive',
  'Professional',
  'Corporate',
  'Enterprise'
] as const;

const MEMBERSHIP_FEATURES = [
  { value: 'premium_content', label: 'Premium content (+)' },
  { value: 'vip_tickets', label: 'VIP ticket pricing' },
  { value: 'live_webinars', label: 'Live webinars' },
  { value: 'on_demand_library', label: 'On-demand library' },
  { value: 'member_only_site_tours', label: 'Member-only site tours' },
  { value: 'member_only_networking', label: 'Member-only networking' },
  { value: 'vip_event_seating', label: 'VIP event seating' },
  { value: 'award_submissions', label: 'Award submissions' }
] as const;

type MembershipFeatureValue = (typeof MEMBERSHIP_FEATURES)[number]['value'];

type MembershipTiers = (typeof MEMBERSHIP_TIERS)[number];

export const MEMBERSHIP_PLANS: {
  name: MembershipTiers;
  price: string;
  priceIsFrom: boolean;
  priceIsFixed: boolean;
  billingTypeDescription: string;
  description: string;
  features: Partial<Record<MembershipFeatureValue, string | boolean>>;
}[] = [
  {
    name: 'Executive',
    price: '$29 per user',
    priceIsFrom: false,
    priceIsFixed: false,
    billingTypeDescription: 'per month, billed monthly',
    description:
      'Executive readers looking to stay informed and secure VIP discounts.',
    features: {
      premium_content: true,
      vip_tickets: true,
      vip_event_seating: false
    }
  },
  {
    name: 'Professional',
    price: '$69 per user',
    priceIsFrom: false,
    priceIsFixed: false,
    billingTypeDescription: 'per month, billed quarterly',
    description: '',
    features: {}
  }
];

export const ACTIVE_OWING_SUBSCRIPTION_STATUS = [
  'past_due',
  'unpaid',
  'incomplete',
  'incomplete_expired'
];

const CITIES: {
  value: string;
  label: string;
}[] = [
  { value: 'Adelaide', label: 'Adelaide' },
  { value: 'Brisbane', label: 'Brisbane' },
  { value: 'Canberra', label: 'Canberra' },
  { value: 'Darwin', label: 'Darwin' },
  { value: 'Gold Coast', label: 'Gold Coast' },
  { value: 'Hobart', label: 'Hobart' },
  { value: 'Melbourne', label: 'Melbourne' },
  { value: 'Newcastle', label: 'Newcastle' },
  { value: 'Parramatta', label: 'Parramatta' },
  { value: 'Perth', label: 'Perth' },
  { value: 'Sydney', label: 'Sydney' },
  { value: 'International', label: 'International' },
  { value: 'Other', label: 'Other' }
];

const INDUSTRIES: {
  value: string;
  label: string;
}[] = [
  {
    value: 'Accounting and financial services',
    label: 'Accounting and financial services'
  },
  {
    value: 'Advertising and marketing services',
    label: 'Advertising and marketing services'
  },
  { value: 'Architecture and design', label: 'Architecture and design' },
  { value: 'Building certification', label: 'Building certification' },
  {
    value: 'Building supplies and products',
    label: 'Building supplies and products'
  },
  { value: 'Consultancy', label: 'Consultancy' },
  { value: 'Construction', label: 'Construction' },
  { value: 'Development', label: 'Development' },
  { value: 'Education', label: 'Education' },
  { value: 'Engineering', label: 'Engineering' },
  {
    value: 'Facility & property management',
    label: 'Facility & property management'
  },
  { value: 'Government', label: 'Government' },
  { value: 'Human resources', label: 'Human resources' },
  { value: 'Industry association', label: 'Industry association' },
  { value: 'Investment', label: 'Investment' },
  { value: 'Legal', label: 'Legal' },
  { value: 'Planning', label: 'Planning' },
  { value: 'Property finance', label: 'Property finance' },
  { value: 'Project management', label: 'Project management' },
  { value: 'Quantity surveying', label: 'Quantity surveying' },
  { value: 'Real estate agency', label: 'Real estate agency' },
  { value: 'Research and advisory', label: 'Research and advisory' },
  { value: 'Surveying', label: 'Surveying' },
  { value: 'Technology and software', label: 'Technology and software' },
  { value: 'Valuation', label: 'Valuation' },
  { value: 'Other', label: 'Other' }
];

const POSITIONS: {
  value: string;
  label: string;
}[] = [
  { value: 'C-suite, director or owner', label: 'C-suite, director or owner' },
  { value: 'Senior manager', label: 'Senior manager' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Operations', label: 'Operations' },
  { value: 'Administration', label: 'Administration' },
  { value: 'Other', label: 'Other' }
];

const INTERESTS: {
  value: string;
  label: string;
}[] = [
  { value: 'Aged care and retirement', label: 'Aged care and retirement' },
  { value: 'Alternative assets', label: 'Alternative assets' },
  { value: 'Build-to-rent', label: 'Build-to-rent' },
  { value: 'Commercial', label: 'Commercial' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Hotels', label: 'Hotels' },
  { value: 'Industrial', label: 'Industrial' },
  { value: 'Residential', label: 'Residential' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Student accommodation', label: 'Student accommodation' }
];

export const USER_PREFERENCES = {
  CITIES,
  POSITIONS,
  INDUSTRIES,
  INTERESTS
};
